import React from 'react';
import store from '../components/Stores/SurveyStore'
import SurveyPage from '../components/SurveyPage';
import SurveyTitleArea from '../components/SurveyTitleArea';
import SurveySection from '../components/SurveySection';
import SurveyElement from '../components/SurveyElement';
import SurveyContentContainer from '../components/SurveyContentContainer';
import SurveyConditionalSegment from '../components/SurveyConditionalSegment'
import { ElementType, NumberFormat, SelectCombos, CommonResponses, } from '../Enums/constants';


export const PabsUkPensionersTab = () => {
  return (
    <SurveyPage pageName='Pensioners'>
      <SurveyTitleArea labelText='' />
      <SurveyContentContainer>
        <SurveySection labelText='Pension Payments'>
          <SurveyElement
            questionNumber='30'
            labelText='Were any of your pension payrolls late vis-à-vis your normal payment cycle?'
            note='For example, a payroll might be late because of IT problems'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='SACRSLatePayroll'
          />
          <SurveyConditionalSegment
            showIf={{
              SACRSLatePayroll: {
                not: CommonResponses.NO.toLowerCase()
              }
            }}
          >
            <SurveyElement
              questionNumber='30.a'
              labelText='How many payrolls were late?'
              inputType={ElementType.NUMBER}
              placeholder='# payrolls'
              subQuestion
              name='SACRSLatePayrollHowMany'
            />
            <SurveyElement
              questionNumber='30.b'
              labelText='On average, how many days late were they?'
              inputType={ElementType.NUMBER}
              placeholder='# days'
              subQuestion
              name='SACRSLatePayrollDays'
            />
            <SurveyElement
              questionNumber='30.c'
              labelText='How many pensioners were affected?'
              inputType={ElementType.NUMBER}
              placeholder='# pensioners'
              subQuestion
              name='SacrsLatePensioners'
            />
          </SurveyConditionalSegment>
        </SurveySection>
        <SurveySection labelText='Pension Increases'>
          <SurveyElement
            questionNumber='31'
            labelText='Were any pension increases late in the year (i.e., after the date the increase should have taken effect)?'
            note={`For schemes supplying data for the year to March ${store.currentYear}, this should include any pension increases that were due between 1st April ${store.currentYear - 1} and 31st March ${store.currentYear}, i.e., increases from 1st April ${store.currentYear} should be ignored).`}
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
            name='PensionIncreaseLate'
          />
          <SurveyConditionalSegment
            showIf={{
              PensionIncreaseLate: {
                not: CommonResponses.NO.toLowerCase()
              }
            }}
          >
            <SurveyElement
              questionNumber='31.a'
              labelText='How many pensioners were affected?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='# pensioners'
              subQuestion
              name='PensionIncreaseLateAffected'
            />
            <SurveyElement
              questionNumber='31.b'
              labelText='On average, how many months late were the increases?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder='# months'
              subQuestion
              name='PensionIncreaseLateMonths'
            />
          </SurveyConditionalSegment>
          <SurveyElement
            questionNumber='32'
            labelText='Were any pensions increased by the wrong amount in the year (i.e., the increase was wrong and you had to fix the problem at a later stage)?'
            name='PensionIncreaseWrong'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.YES_NO}
          />
          <SurveyConditionalSegment
            showIf={{
              PensionIncreaseWrong: {
                not: CommonResponses.NO.toLowerCase()
              }
            }}
          >
            <SurveyElement
              questionNumber='32.a'
              labelText='How many pensioners were affected?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.INTEGER}
              placeholder='# pensioners'
              subQuestion
              name='PensionIncreaseErrorAffected'
            />
            <SurveyElement
              questionNumber='32.b'
              labelText='How long on average, in months, did it take to correct the errors?'
              inputType={ElementType.NUMBER}
              format={NumberFormat.DECIMAL1}
              placeholder='# months'
              subQuestion
              name='PensionIncreaseErrorMonths'
            />
          </SurveyConditionalSegment>
        </SurveySection>

        <SurveySection labelText='P60s'>
          <SurveyElement
            questionNumber='33'
            labelText='How many days (including weekends) after the tax year end did you send the bulk of your P60s? (I.e., if you sent your P60s on 30th April, the answer would be 24 days)'
            inputType={ElementType.NUMBER}
            placeholder='#'
            name='optionsP60Days'
            format={NumberFormat.INTEGER}
          />
        </SurveySection>

        <SurveySection labelText='Elapsed Times - Death-In-Retirement'>
          <p>
            We are asking for details of elapsed times, which reflect the
            members actual service experience, measured from the point you were
            first notified to the point of fulfilment. If you don't measure
            elapsed times then please feel free to estimate, i.e., a typical
            death-in-retirement process might take 1 month from the point of
            notification (accepting there might be a wide range).
          </p>
          <SurveyElement
            questionNumber='34'
            labelText='What is the average elapsed time, in weeks, from the point of initial notification to the point of paying any lump sum, i.e., the balance of any pension in the guaranteed period (including delays caused by third-parties)?'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder='# weeks, unknown, n/a'
            name='UKPensionersElapsedTimesDeathLumpSum'
            allowUnknown
            allowNA
          />
          <SurveyElement
            questionNumber='34.a'
            labelText='Is this measured or estimated?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.MEASURED_ESTIMATED}
            name='UKPensionersElapsedTimesDeathLumpSumMeasured'
          />
          <SurveyElement
            questionNumber='35'
            labelText='What is the average elapsed time, in weeks, from the point of initial notification to set up any dependents pension (including delays caused by third-parties)?'
            inputType={ElementType.NUMBER}
            format={NumberFormat.INTEGER}
            placeholder='# weeks, unknown'
            name='UKPensionersElapsedTimesDeathDependentsPension'
            allowUnknown
          />
          <SurveyElement
            questionNumber='35.a'
            labelText='Is this measured or estimated?'
            inputType={ElementType.RADIOBUTTON}
            options={SelectCombos.MEASURED_ESTIMATED}
            name='UKPensionersElapsedTimesDeathDependentsPensionMeasured'
          />
        </SurveySection>
      </SurveyContentContainer>
    </SurveyPage>
  )
}